import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import { useTranslation } from "react-i18next";
function CalculationDetails(props) {

  const { t }     = useTranslation();
  let pageContent = props.pageContent;

  return (
    <Grid item xs={6}>
    <Card mb={2} variant="outlined">
      <CardContent>
        <Grid item xs={12} my={2}>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            {t('Calculation Details')}
          </Typography>          
        </Grid>
        <Grid container spacing={0} mt={1}>
          <Grid item xs={12}>
            <Typography sx={{ fontSize: 14 }} component="div" gutterBottom>
              <Box className="addressBox">
                  <Box className="addressBoxLeft" sx={{width: "160px"}}>{t('Total Product Price')}</Box>
                  <Box className="addressBoxMiddle">:</Box>
                  <Box className="addressBoxRight">
                    {`₹${pageContent.totalPrice.toFixed(2)}`}
                  </Box>
              </Box>  
            </Typography>
            <Typography sx={{ fontSize: 14 }} component="div" gutterBottom>
              <Box className="addressBox">
                  <Box className="addressBoxLeft" sx={{width: "160px"}}>{t('Admin Commission')+" ("+pageContent.adminCommissionPercentage+"%)"}</Box>
                  <Box className="addressBoxMiddle">:</Box>
                  <Box className="addressBoxRight">
                    {`₹${pageContent.adminCommission.toFixed(2)}`}
                  </Box>
              </Box>  
            </Typography>            
            <Typography sx={{ fontSize: 14 }} component="div" gutterBottom>
              <Box className="addressBox">
                  <Box className="addressBoxLeft" sx={{width: "160px"}}>{t('Tax Bearer')}</Box>
                  <Box className="addressBoxMiddle">:</Box>
                  <Box className="addressBoxRight">
                    {`₹${pageContent.totalTax.toFixed(2)}`}
                    <> ({t('Admin')})</>
                  </Box>
              </Box>  
            </Typography>            
            <Typography sx={{ fontSize: 14 }} component="div" gutterBottom>
              <Box className="addressBox">
                  <Box className="addressBoxLeft" sx={{width: "160px"}}>{t('Shipping Charge Bearer')}</Box>
                  <Box className="addressBoxMiddle">:</Box>
                  <Box className="addressBoxRight">
                    {`₹${pageContent.shippingPrice.toFixed(2)}`}
                    {pageContent.shippingPriceBearer === 1 ? <> ({t('Admin')})</> : <> ({t('Seller')})</>}
                  </Box>
              </Box>  
            </Typography>           
            <Typography sx={{ fontSize: 14 }} component="div" gutterBottom>
              <Box className="addressBox">
                  <Box className="addressBoxLeft" sx={{width: "160px"}}>{t('discountPriceBearer')}</Box>
                  <Box className="addressBoxMiddle">:</Box>
                  <Box className="addressBoxRight">
                    {`₹${pageContent.totalDiscount.toFixed(2)}`} 
                    {pageContent.discountPriceBearer === 1 ? <> ({t('Admin')})</> : <> ({t('Seller')})</>}
                  </Box>
              </Box>  
            </Typography>      
            <Typography sx={{ fontSize: 14 }} component="div" gutterBottom>
              <Box className="addressBox">
                  <Box className="addressBoxLeft" sx={{width: "160px"}}>{t('Vendor Payable')}</Box>
                  <Box className="addressBoxMiddle">:</Box>
                  <Box className="addressBoxRight">
                    {`₹${pageContent.vendorPayable.toFixed(2)}`}
                  </Box>
              </Box>  
            </Typography>     
          </Grid>
        </Grid>                   
      </CardContent>  
    </Card> 
  </Grid>  
  )
}

export default CalculationDetails;
